import { useState, useCallback, useRef } from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import type { DropResult } from 'react-beautiful-dnd';
import type { GoalWithIds } from '../../../../../../../common/types';
import { NEW } from '../../../../../../../common/ui/constants.tsx';
import { useGoalCounter } from '../../../../../../../controllers/goal-counter';
import { reorderList, appendNewGoal } from './utils';

export const useGoalsState = (initialGoals: GoalWithIds) => {
	const newGoalReference = useRef(0);
	const [goals, setGoals] = useState<GoalWithIds>(initialGoals);

	const [, actions] = useGoalCounter();

	const onDragEnd = useCallback(
		({ source, destination }: DropResult) => {
			if (!destination) {
				return;
			}

			if (destination.index === source.index) {
				return;
			}

			const reorderedList = reorderList(goals, source.index, destination.index);

			setGoals(reorderedList);
		},
		[goals],
	);

	const onAppendNewGoal = useCallback(
		(metricId: number) => {
			newGoalReference.current += 1;
			const newList = appendNewGoal(goals, {
				id: `new-with-id-${newGoalReference.current}`,
				jqlQuery: '',
				duration: '',
				calendarId: undefined,
				defaultGoal: false,
				timeMetricId: 0,
				subGoals: [],
				fieldState: NEW,
				metricId,
			});
			actions.incrementGoalCounter(1);
			// @ts-expect-error - TS2345 - Argument of type 'readonly [...GoalWithId[], GoalWithId]' is not assignable to parameter of type 'SetStateAction<GoalWithIds>'.
			setGoals(newList);
		},
		[goals, actions],
	);

	return [goals, setGoals, onDragEnd, onAppendNewGoal] as const;
};
